const announcementsPT = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} anúncios não lidos",
            "empty": "Sem anúncios",
            "newBadge": "Novo",
            "dismissAll": "Descartar tudo",
        },
        "modal": {
            "defaultTitle": "Anúncio",
        },
        "table": {
            "title": "Anúncios",
            "column": {
                "title": "Título",
                "datePosted": "Data de publicação",
                "dismissed": "Descartado",
                "status": "Estado",
                "action": "Ação",
            },
            "status": {
                "read": "Lido",
                "unread": "Não lido",
            },
            "csv": {
                "statusRead": "Lido",
                "statusUnread": "Não lido",
                "dismissedYes": "Descartado",
                "dismissedNo": "Não descartado",
            },
            "action": {
                "view": "Ver",
            },
            "button": {
                "exportCsv": "Exportar CSV",
            },
        },
    },
};

export default announcementsPT;
